<template>
  <div id='questionDetail1'>
       <!-- 填空题 -->
	    <!-- <div class='loading' v-if='loadShow'></div> -->
        <div class='title'>{{Q.title}}</div>
        <div class='title2'>{{Q.question_desc}}</div> 
        <input type="text" v-model="message" :placeholder="Q.keyword=='name'?'请输入姓名…':'请输入…'" class='qInput' malength="11">
        <div class='nestQ'>
            <img src="../assets/icon-next.png" alt="下一题"  class="image000" v-if='!message'>
            <img src="../assets/icon-next.png" alt="下一题" v-else  @click='nestQ'>
        </div>
  </div>
</template>

<script>
export default {
  name: 'Q1',
  props: {
    Q: Object,
    fn: Function
  },
  data:function(){
    return{
      message:"",
      placeholderTxt:"请输入…",
	  loadShow:true,
    }
  },
 
 created:function(){
	 let that = this
	 this.loadShow =true
     setTimeout(()=>{
     	that.loadShow =false
     },1000)
	 this.$parent.goOnQuestion()
	 
  },
  watch:{
    Q:{
        handler(newValue, oldValue) {
　　　　　　this.Qreset()
　　　　},
    }
  },
  methods: {


   nestQ() {
        if(!this.message)return
        let _questions=this.$store.state.questions
        _questions.is_up = 0
        _questions.record_id = this.Q.record_id
        _questions.member_id = this.$store.state.member_id
        _questions.question ={
                              question_id:this.Q.id,
                              answer_ids:[],
                              answer:this.message
                            }
	    
		console.log("写入1",_questions)
		$("#questionDetail1").focus()
        this.$store.commit("modifyQuestions",_questions)
        this.fn()
		this.loadShow =true
    },
    // 重置
   Qreset(){
	   let that = this
			this.message=""
			this.loadShow =true
			setTimeout(()=>{
				that.loadShow =false
			},1000)
    },
  }
}
</script>  

<style>
#questionDetail1{
  width: 7.5rem;
  padding-top: 2.64rem;
  padding-bottom: 2rem;
  overflow-y: scroll;
  height: 100%;
  box-sizing: border-box;
  position: relative;

}
#questionDetail1 .loading{
	width: 100%;
	height: 100%;
	position:absolute;
	z-index: 900;
	/* background:rgba(0,0,0,0.5); */
	line-height:6rem;
	color: rgba(0,0,0,0.5);
	font-size: 0.32rem;
	text-align: center;
}
#questionDetail1::-webkit-scrollbar {display:none}
#questionDetail1 .title{
  text-align:center;
  min-height:0.7rem;
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium;
  font-weight:600;
  letter-spacing:0.01rem;
  color:rgba(20,20,20,1);
  line-height:0.7rem;
  padding:0 0.9rem; 
}
#questionDetail1 .title2{
   text-align: center;
    color: #727171;
    font-weight: normal;
    font-size: 0.3rem;
    margin: 0.075rem 0 0.6rem;
    padding:0 0.9rem; 
} 
#questionDetail1 .qInput{
    height: 1.1rem;
    width: 6rem;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.3rem;
    margin:0 auto 0.9rem;
    text-align: center;
    font-size: 0.3rem;
    box-shadow: 0px 20px 50px -20px rgba(236, 163, 129, 0.5);
    outline: none;
    border:none;
}
#questionDetail1 .nestQ{
  width:1.2rem;
  height:1.2rem;
  margin:0 auto;
}
#questionDetail1 .nestQ img{
  width:1.2rem;

}
</style>